<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="取消订单" left-arrow fixed
                     @click-left="back"/>
        <p class="c-title">您确定要取消下面的订单吗?</p>
        <div class="c-body">
            <p><span class="c-req">*</span> 订单号: {{orderId}}</p>
            <p><span class="c-req">*</span> 取消原因:</p>
            <van-radio-group v-model="resId">
                <van-radio name="改买其他商品">改买其他商品</van-radio>
                <van-radio name="从其他店铺购买">从其他店铺购买</van-radio>
                <van-radio name="3">其他原因</van-radio>
            </van-radio-group>
            <van-field v-model="content"
                       type="textarea"
            />
        </div>
        <div class="jump-warphd-foot">
            <van-button size="large" @click="save">提 交</van-button>
        </div>
    </div>
</template>
<script>
    import {
        NavBar,
        Cell,
        CellGroup,
        Field,
        Button,
        Row,
        Col,
        Radio,
        RadioGroup
    } from "vant";

    export default {
        name: "userordercancel",
        components: {
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Radio.name]: Radio,
            [RadioGroup.name]: RadioGroup
        },
        data() {
            return {
                resId: "改买其他商品",
                id: this.$route.query.id,
                content: "",
                orderId: this.$route.query.orderId
            };
        },
        methods: {
            back() {
                history.back();
            }, save() {
                let that = this
                if (that.resId == '3') {
                    that.resId = ''
                }
                that.$api.post(
                    that.jumuc.order.cancelOrder,
                    {"orderId": that.id, "reason": that.resId, "otherStateInfo": that.content},
                    successRes => {
                        if (successRes.success) {
                            that.$router.push({
                                path: '/user/order'
                            })
                        } else {
                            that.$toast(successRes.msg)
                        }
                    }
                )
            }
        }
    };
</script>
<style lang="less">
    @bule-thame: #3c6eeb;

    .jump-warphd {
        p {
            font-size: 14px;
            line-height: 28px;
        }
        .c-title {
            padding: 10px 10px;
        }
        .van-radio-group {
            padding: 10px 0;
            font-size: 14px;
            .van-radio {
                padding: 4px 0;
            }
        }
        .c-body {
            padding: 10px;
            .van-field {
                border: 1px solid #f7f7f7;
            }
        }
        &-foot {
            padding: 10px 15px;
            font-size: 14px;
            button {
                background-color: @bule-thame;
                color: white;
                font-weight: 700;
                border-radius: 5px;
                margin: 25px 0 10px;
            }
        }
    }
</style>
